export const styles = theme => ({
  popover: {
    minWidth: '350px',
    maxHeight: '425px'
  }
});
